module.exports = __webpack_public_path__ + "static/media/click.ef0348fa.cur";